module.exports = __webpack_public_path__ + "img/bedrohungen.e1a39f20.png";